import { render, staticRenderFns } from "./TransactionsMain.vue?vue&type=template&id=844c6b28&scoped=true"
import script from "./TransactionsMain.vue?vue&type=script&lang=js"
export * from "./TransactionsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844c6b28",
  null
  
)

export default component.exports